import { map } from 'lodash';

export default function (object) {
  return map(object, (title, key) => {
    return {
      label: title,
      value: key,
    };
  });
}
